const CURRENT_VALIDATED_CERT_ACCESS_TOKEN_KEY = 'cvtoken#';

export function saveValidatedCertificateAccessToken(certId, accessToken) {
    return sessionStorage.setItem(buildAccessTokenKey(certId), accessToken);
}

export function getValidatedCertificateAccessToken(certId) {
    return sessionStorage.getItem(buildAccessTokenKey(certId));
}

export function removeValidatedCertificateAccessToken(certId) {
    return sessionStorage.removeItem(buildAccessTokenKey(certId));
}

function buildAccessTokenKey(certId) {
    return CURRENT_VALIDATED_CERT_ACCESS_TOKEN_KEY.concat(certId);
}

export function getDownloadFormat(certId, wallet) {
    return sessionStorage.getItem(buildDownloadFormatKey(certId, wallet));
}

export function saveDownloadFormat(certId, wallet, format) {
    return sessionStorage.setItem(buildDownloadFormatKey(certId, wallet), format);
}

function buildDownloadFormatKey(certificateId, wallet) {
    return `currentDownloadFormat#${certificateId}#${wallet}`;
}
